function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15.71,
  cy: 18.14,
  r: 15.71
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.61 8v20.28H49.32V8zm5-5H44.32v30.28h30.29zM90.32 9.07v18.14l15.71 9.06 15.7-9.06V9.07L106.03 0z"
}));

function SvgIconDiversity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 121.73 36.28"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTIxLjczIDM2LjI4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiNmZmYiPjxjaXJjbGUgY3g9IjE1LjcxIiBjeT0iMTguMTQiIHI9IjE1LjcxIi8+PHBhdGggZD0ibTY5LjYxIDh2MjAuMjhoLTIwLjI5di0yMC4yOHptNS01aC0zMC4yOXYzMC4yOGgzMC4yOXoiLz48cGF0aCBkPSJtOTAuMzIgOS4wN3YxOC4xNGwxNS43MSA5LjA2IDE1LjctOS4wNnYtMTguMTRsLTE1LjctOS4wN3oiLz48L2c+PC9zdmc+";
export { SvgIconDiversity as ReactComponent };